









export default {
    props: {
        name: String,
        minValue: Number,
        maxValue: Number,
        canBeNegative: Boolean,
        value: {
            default: 0,
            type: Number
        },
        disableMax: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            counter: this.value
        }
    },
    computed: {
        isMinDisabled() {
            return this.disabled
        },
        isMaxDisabled() {
            console.log("Disabled", this.disableMax, this.disabled);
            return this.disableMax || this.disabled;
        },
        isAllDisabled() {
            return this.isMinDisabled && this.isMaxDisabled;
        }
    },
    methods: {
        reset: function () {
            this.counter = this.value;
            this.emitValue();
        },
        add: function () {
            if ((this.maxValue != null && this.maxValue > this.counter) || this.maxValue == null) {
                this.counter = this.counter + 1;
                this.emitValue();
            }
        },
        subtract: function () {
            if (this.canBeNegative == false && this.counter > 0 || this.canBeNegative == true) {
                if ((this.minValue != null && this.minValue < this.counter) || this.minValue == null) {
                    this.counter = this.counter - 1;
                    this.emitValue();
                }
            }
        },
        inputChange: function () {

        },
        emitValue: function () {
            this.$emit('valueChanged', this.counter);
        }
    }
}
